export default function ProjectLogoIcon({ size = 50 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 46 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="46" rx="7" fill="#FFB64F" />
      <path
        d="M10.2057 42.6667H13.4114V29.3333H32.6457V42.6667H35.8514V24.9167L23.0286 19.5833L10.2057 24.9167V42.6667ZM7 46V22.6667L23.0286 16L39.0571 22.6667V46H29.44V32.6667H16.6171V46H7ZM18.22 46V42.6667H21.4257V46H18.22ZM21.4257 41V37.6667H24.6314V41H21.4257ZM24.6314 46V42.6667H27.8371V46H24.6314Z"
        fill="#E77700"
      />
    </svg>
  );
}
